import axios from 'axios';

const serverURL = process.env.NODE_ENV == "production" ? process.env.REACT_APP_HEROKU_SERVER_URL : process.env.REACT_APP_LOCAL_NODE_SERVER_URL;
const API = axios.create({ baseURL: `${serverURL}` });

API.interceptors.request.use((req) => {
    if (localStorage.getItem('profile')) {
        req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
    }

    return req;
});

/* authentication */
export const register = (formData) => API.post('/users/register', formData);
export const login = (formData) => API.post('/users/login', formData);

/* capsule */
export const saveCapsule = (data) => API.post('/capsule/save', data);
export const getAll = () => API.get('/capsule/all');
export const getCount = () => API.get('/capsule/count');